import React, { useMemo, useState } from 'react';
import Basic from 'views/AuthView/styles/themes/TexterBasic';
import { Texter } from 'kinedu-react-components';
import Button from '../../Button';
import useAuth from '../../hooks/useAuth';
import { useTranslation } from 'react-i18next';

import StyledForgotPasswordView, {
  Container,
  Title,
  Subtitle,
  LabelsWrapper,
  InputGroup,
  ErrorMessage,
} from './styles';

export const isValidEmail = (email: string) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

const ForgotPasswordView = ({ onSuccess }: { onSuccess: Function }) => {
  const { t } = useTranslation();
  const { sendResetPasswordEmail } = useAuth();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [isBusy, setIsBusy] = useState(false);

  const handleForgotPassword = (event: any) => {
    event.preventDefault();
    setError('');


    if (!isValidEmail(email)) {
      setError(t('ERRORS.INVALID_EMAIL'));

      return;
    }

    if (isBusy) {
      return;
    }

    setIsBusy(true);

    sendResetPasswordEmail(email)
      .then(() => {
        onSuccess(email);
        setIsBusy(false);
      })
      .catch(err => {
        console.log('%c🚫 err', 'background: #a20046; color: #ffa8a6; font-size: 16px', err);
        if (err) {
          let errorText = t('ERRORS.GENERAL_ERROR');

          if (err?.response?.data?.error === 'not found') {
            errorText = t('ERRORS.EMAIL_NOT_FOUND');
          }

          setError(errorText);
        }
        setIsBusy(false);
      });
  };

  const isButtonDisabled = useMemo(() => {
    return email === null || email === '';
  }, [email]);

  return (
    <StyledForgotPasswordView>
      <Container>
        <Title className="title">{t('auth:FORGOT_PASS_VIEW.TITLE')}</Title>
        <Subtitle className="text">{t('auth:FORGOT_PASS_VIEW.DESC')}</Subtitle>
        <LabelsWrapper id="labels" onSubmit={handleForgotPassword}>
          <InputGroup className="input-group" id="input-group-email">
            <Texter
              value={email}
              type="email"
              label="Email"
              theme={Basic}
              placeholder="example@email.com"
              onChange={setEmail}
            />
            <ErrorMessage>{error}</ErrorMessage>
          </InputGroup>
          <Button
            disabled={isButtonDisabled}
            shadowColored
            color="primary"
            style={{ maxWidth: '290px', margin: '0 auto' }}
            type="submit"
            fill
            small
          >
            {t('auth:FORGOT_PASS_VIEW.SEND_EMAIL')}
          </Button>
        </LabelsWrapper>
      </Container>
    </StyledForgotPasswordView>
  );
};

export default ForgotPasswordView;
